import { AnalyticsBrowser } from '@segment/analytics-next'
import { type App, type Plugin } from 'vue'
import { type AnalyticsClient, setSegmentClient } from './analyticsClients'

export interface SegmentOptions {
  writeKey: string
}

export const segmentPlugin: Plugin = {
  async install(_: App, { writeKey }: SegmentOptions): Promise<void> {
    setSegmentClient(undefined)

    if (!writeKey) return

    try {
      const instance = AnalyticsBrowser.load({ writeKey })

      instance.catch(() => {
        console.error('Error loading segment')
        setSegmentClient(undefined)
      })

      setSegmentClient(instance as AnalyticsClient, instance)
    } catch (err) {
      console.error('Error loading segment: ', err)
    }
  },
}
